<template>
  <div class="settings settingsWrapper">
    <div class="settings__block">
      <div class="settings__container">
        <el-row class="settings__row">
          <r-text>{{ $t("settings.user-config") }}</r-text>
        </el-row>
        <el-row class="settings__row">
          <el-checkbox-group
            v-model="checkedConfigs"
            @change="handleCheckedConfigsChange"
          >
            <el-checkbox
              class="r-checkbox"
              v-for="config in configs"
              :label="config"
              :key="config"
            >
              <r-text>{{ $t(config.toLowerCase()) }}</r-text>
            </el-checkbox>
          </el-checkbox-group></el-row
        >
        <el-row class="settings__row">
          <el-checkbox
            class="r-checkbox"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >
            <r-text>{{ $t("settings.reset-all") }}</r-text>
          </el-checkbox></el-row
        >
        <el-row class="settings__row text-right">
          <el-button
            @click="openModalBox"
            class="r-button"
            :loading="isLoading"
            size="mini"
            type="danger"
            :disabled="!checkedConfigs.length"
            >{{ this.$t("settings.reset-config") }}
          </el-button>
        </el-row>
        <!-- <el-row v-if="!isChrome" class="settings__row">
          <div class="settings__block">
            <el-alert
              :title="$t('info.text::isChrome')"
              type="warning"
              show-icon
            >
            </el-alert>
          </div>
        </el-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import { notifyFactory } from "@/utils";
import { errorParser } from "@/utils";

const userConfigs = ["Book", "Chart", "Map"];

export default {
  data() {
    return {
      checkAll: false,
      configs: userConfigs,
      checkedConfigs: [],
      isIndeterminate: false,

      isLoading: false,
      token: this.$store.state.auth.token,
      isChrome: true
    };
  },
  computed: {
    profileId() {
      return this.$store.state.profiles.currentProfile.id;
    }
  },
  methods: {
    openModalBox() {
      const warningText = `${this.$t("modalWarningText")}`;
      const warningTitle = `${this.$t("modalWarningTitle")}`;
      const confirmButtonText = `${this.$t("modalConfirmButton")}`;
      const cancelButtonText = `${this.$t("modalCancelButton")}`;
      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        type: "warning",
        confirmButtonText,
        cancelButtonText
      })
        .then(async () => {
          await this.resetUserConfig();
        })
        .catch(() => {});
    },
    async resetUserConfig() {
      const message = `${this.$t("infoText")}`;
      const messageTitle = `${this.$t("infoTitle")}`;
      const errorMessage = `${this.$t("errorText")}`;
      const errorTitle = `${this.$t("errorTitle")}`;
      const modules = this.checkedConfigs.join(",").toLowerCase();

      try {
        this.isLoading = true;
        this.$store.commit("RESET_USER_CONFIG", this.checkedConfigs);
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
        await this.$store.dispatch("POST_REQUEST", {
          url: `user/delete_source_config?module=${modules}&profile_id=${
            this.profileId
          }`
        });
        document.location.reload(true);
        this.$notify(notifyFactory("info", messageTitle, message));
        this.isLoading = false;
      } catch (e) {
        errorParser.call(this, e, errorMessage, errorTitle);
        this.isLoading = false;
      }
    },
    handleCheckAllChange(val) {
      this.checkedConfigs = val ? userConfigs : [];
      this.isIndeterminate = false;
    },
    handleCheckedConfigsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.configs.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.configs.length;
    }
  },
  created() {
    this.isChrome = /Chrome/.test(navigator.userAgent);
  }
};
</script>

<style lang="scss">
.settings {
  &__row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-checkbox {
      &-group {
        display: flex;
        justify-content: space-between;
        padding-right: 32px;
        box-sizing: border-box;
      }
    }
  }
  .text-right {
    text-align: right;
  }
}
</style>

<i18n>
{
  "ru": {
    "book": "Справочник",
    "chart": "Графики",
    "map": "Карта",
    "settings.reset-all": "Все настройки",
    "settings.user-config": "Выберите необходимые параметры для сброса",
    "settings.reset-config": "Сбросить настройки",
    "modalConfirmButton": "Да",
    "modalCancelButton": "Нет",
    "modalWarningTitle": "Предупреждение",
    "modalWarningText": "Все настройки стилизации, размеры и местоположения окон, пользовательские папки в списке источников данных будут сброшены до настроек по умолчанию. Продолжить?",
    "errorText": "Произошла ошибка. Попробуйте обновить страницу",
    "errorTitle": "Ошибка",
    "infoText": "Вы успешно сбросили настройки, перезагрузите страницу",
    "infoTitle": "Уведомление",
    "info.text::isChrome": "Система находится в стадии активной разработки и на данный момент  корректно работает только в браузере Google Chrome"
  },
  "en": {
    "book": "Book",
    "chart": "Charts",
    "map": "Map",
    "settings.reset-all": "All settings",
    "settings.user-config": "Select the options you want to reset.",
    "settings.reset-config": "Reset configs",
    "modalConfirmButton": "Yes",
    "modalCancelButton": "Cancel",
    "modalWarningTitle": "Warning",
    "modalWarningText": "All styling settings, window sizes and locations, user folders in the list of data sources will be reset to default settings. Continue?",
    "errorText": "An error has occurred. Try to refresh the page",
    "errorTitle": "Error",
    "infoText": "You have successfully reset the settings, reload the page",
    "infoTitle": "Notification",
    "info.text::isChrome": "The system is under active development and currently works only in the Google Chrome."
  }
}
</i18n>
